/**
 * Created by Babu on 16/5/11.
 */

var React = require('react');

var _ = require("underscore");

var ALikeStore = require("../store/ALikeStore");

var Dispatcher = require("../Dispatcher");

var {ActionConstants, EventConstants} = require("../Constants");

var ReactDOM = require("react-dom");

var FilterType = require("../conf/filter-type");

var {object2class} = require("../util/clazz");

module.exports = React.createClass({
    displayName: "FilterMenu",

    getInitialState(){

        var defaultState = {
            filterType: null,
            continentId: null,
            countryId: null,
            branchId: null,
            topicsId: [],
            citiesId: [],
            highlightId: null,
            daysId: [],
            sortId: null,
            openViewTopics: false,
            openViewCities: false,
            openViewHighlights: false,
            openViewDays: false,
            isSelectedTarget: false,
            isSelectedMore: false,
            isSelectedSort: false,
            page: 1,
            pageSize: 9,
            walleHasStartFalg: 0,
            scrollTop: 0,
            filterData:{}
        };

        var hash = window.location.search;
        if(hash){
            var hashObj = this._getQueryParams();
            defaultState = {
              continentId: +hashObj.continent || ( +hashObj.countries ? ALikeStore.getContinentIdByCountryId( +hashObj.countries ) : "" ),
                countryId: +hashObj.countries || "",
                branchId:  +hashObj.branch || "",
                topicsId:  hashObj.topics || [],
                citiesId:  hashObj.cities || [],
                highlightId:  +hashObj.highlights || "",
                daysId:  hashObj.day || [],
                sortId:  +hashObj.sort >=0 ? hashObj.sort : "" ,
                page: +hashObj.page || 1,
                pageSize: 9,
                walleHasStartFalg:  hashObj.walleHasStartFalg || 0,
                scrollTop: 0
            }
        }


        return defaultState;
    },
    /**
     * 取得HASH值
     * @private
     */
    _getQueryParams(){
        var hash = window.location.search;
        var hashJson = '{"' + decodeURIComponent(hash).replace(/\?/g,"").replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"').replace(/\//g,'') + '"}';
        try{
            var hashObj = JSON.parse(hashJson)
        }catch(e){
            var hashObj = null;
        }
        _.map(hashObj,function(v,k){
            if(v===""){
                delete hashObj[k];
                return "";
            }
            if(k==="topics" || k==="cities"|| k==="day"){

                var _arr = v.split(",") || [];

                if(_arr.length>1){
                    _arr = _.map(_arr,function(i){
                        if( k!=="day"){
                            return parseInt(i) || "";
                        }else{
                            return i;
                        }

                    });
                }else{
                    _arr = [parseInt(v)] || "";
                    if( k!=="day"){
                        _arr = [parseInt(v)] || "";
                    }else{
                        _arr = [v] || "";
                    }
                }

                hashObj[k] = _arr;

            }else{
                hashObj[k] = parseInt(v)>=0 ? parseInt(v) : "";
            }
        });
        return hashObj;
    },
    /**
     * 设置地址quary
     * @param params
     * @private
     */
    _setQueryParams(params){
        _.mapObject(params,function(v,k){
            if(v==="" || v===null){
                delete params[k];
            }
        });
        var query = $.param(params);
        var location = window.location;
        var localUrl = location.origin + location.pathname + "?" + query;
        window.history.pushState({}, '', localUrl);
    },
    componentWillMount(){

        ALikeStore.on(EventConstants.AJAX_SEARCH_POWER_LIST_COMPLETE, this.on_searchPowerListComplete);
        ALikeStore.on(EventConstants.ACTION_WALLE_HAS_START_FLAG, this.on_walleHasStartFalg);
        this._setTabSelected();
    },
    componentWillUnmount(){

        ALikeStore.off(EventConstants.AJAX_SEARCH_POWER_LIST_COMPLETE, this.on_searchPowerListComplete);
        ALikeStore.off(EventConstants.ACTION_WALLE_HAS_START_FLAG, this.on_walleHasStartFalg);
    },

    componentDidMount(){
        var hash = window.location.search;
        this.handle_scroll();
        if(hash){
            this.handle_result();
        }
    },
    handle_filterContentPosition(){
        var filterType = this.state.filterType;

        var winHeight = $(window).height();
        var menuFilger = $(".mod-target-filter");
        var navWrap = menuFilger.find(".nav");
        var menuWrap = menuFilger.find(".menu");
        var menuHieght = menuFilger.height();
        var menuOffset = menuFilger.position();
        var menuTop = menuOffset.top;
        var menuBtnsHeight = $(".menu .btns").height();
        var toolsTabsHeight = $(".js-sys-tooltabs").height();

        var menuContentHeight = winHeight - menuHieght - menuBtnsHeight - toolsTabsHeight;
        var curScrollTop = this.state.windScrollTop;
        var scrollTop = $(window).scrollTop();
        if(filterType){
            if (scrollTop >= menuTop && !curScrollTop) {
                this.setState({windScrollTop: scrollTop});
            }
            $('body').css({overflow: "hidden",height: winHeight});
            if(!navWrap.hasClass("fixed")){
                navWrap.addClass("fixed")
            }
            if(!menuWrap.hasClass("menuFixed")){
                menuWrap.addClass("menuFixed")
            }
            $(".menu-target, .menu-type, .menu-sort").css({height: menuContentHeight})
        }else{
            $('body').attr("style", "");
            if(navWrap.hasClass("fixed")){
                navWrap.removeClass("fixed")
            }
            if(menuWrap.hasClass("menuFixed")){
                menuWrap.removeClass("menuFixed")
            }
            $(window).scrollTop(curScrollTop);
            this.setState({windScrollTop: 0});
        }

    },
    /**
     * 搜索结果返回后事件
     */
    on_searchPowerListComplete(){
        var page = this.state.page;
        var powerList = ALikeStore.get_powerList();
        //如果是最后一页,刷新页面,跳到第一页
        if(page>1 && powerList.length===0){
            this.handle_result(true);
            return;
        }
        this.handle_hideContent();
    },
    on_walleHasStartFalg(){
        var walleHasStartFalg = ALikeStore.get_walleHasStartFalg();
        this.setState({walleHasStartFalg: walleHasStartFalg});
    },
    /**
     * 要切换过滤器
     * @param type
     */
    handle_switchTab(type){
        var self = this;
        var filterType = this.state.filterType;
        type = filterType === type ? null : type;
        this.setState({filterType: type},function(){
            self.handle_filterContentPosition();
            if(!type){
                self._setCurrentFilter();
            }
        });
    },
    /**
     * 设置tab的状态,当有内容选择时,tab右下角选中状态标亮
     * @private
     */
    _setTabSelected(){
        var continentId = this.state.continentId;
        var countryId = this.state.countryId;
        var branchId = this.state.branchId;
        var isSelectedTarget = false;
        if(continentId || countryId || branchId){
            isSelectedTarget = true;
        }
        this.setState({isSelectedTarget: isSelectedTarget});

        var topicsId = this.state.topicsId;
        var citiesId = this.state.citiesId;
        var highlightId = this.state.highlightId;
        var daysId = this.state.daysId;
        var isSelectedMore = false;
        if((topicsId && topicsId.length>0) || (citiesId &&citiesId.length>0) || highlightId || (daysId && daysId.length>0)){
            isSelectedMore = true;
        }
        this.setState({isSelectedMore: isSelectedMore});

        var sortId = this.state.sortId;
        var isSelectedSort = false;
        if(sortId !== null && sortId !== ""){
            isSelectedSort = true;
        }
        this.setState({isSelectedSort: isSelectedSort});
    },/**
     * 返回tab的状态,当有内容选择时,tab右下角选中状态标亮
     * @private
     */
    _getTabSelected(filterType){
        var isSelectedTarget = this.state.isSelectedTarget;
        var isSelectedMore = this.state.isSelectedMore;
        var isSelectedSort = this.state.isSelectedSort;
        switch(filterType){
            case FilterType.Targe.code:
                return isSelectedTarget;
                break;
            case FilterType.More.code:
                return isSelectedMore;
                break;
            case FilterType.Sort.code:
                return isSelectedSort;
                break;
            default:
                return false;
                break;
        }
    },
    /**
     * 选择洲
     * @param continentId
     */
    handle_setContinent(continentId){
        var self =this;
        this.setState({continentId: continentId, countryId: null, branchId: null, citiesId: [], highlightId: null},function(){
            self._setTabSelected();
        });
    },
    /**
     * 选择国家
     * @param continentId
     */
    handle_setCountry(countryId){
        var self =this;
        this.setState({countryId: countryId, branchId: null, citiesId: [], highlightId: null},function(){
            self._setTabSelected();
        });
    },
    /**
     * 选择分线
     * @param branchId
     */
    handle_setBranch(branchId){
        var self =this;
        this.setState({branchId: branchId, citiesId: [], highlightId: null},function(){
            self._setTabSelected();
        });
    },
    /**
     * 选择主题
     * @param tagId
     */
    handle_setTopic(topicId){
        var topicsId = this.state.topicsId;
        var isPush = _.indexOf(topicsId,topicId);
        if(isPush>-1){
            topicsId = _.without(topicsId,topicId);
        }else{
            topicsId.push(topicId);
        }
        var self =this;
        this.setState({topicsId: topicsId},function(){
            self._setTabSelected();
        });
    },
    /**
     * 选择高点
     * @param highlightId
     */
    handle_setHighlight(highlightId){
        var self =this;
        var currentHighlightId = this.state.highlightId;
        highlightId = currentHighlightId === highlightId ? null : highlightId;
        this.setState({highlightId: highlightId},function(){
            self._setTabSelected();
        });
    },
    /**
     * 选择天数
     * @param dayId
     */
    handle_setDay(dayId){
        var self =this;
        var daysId = this.state.daysId;
        var isPush = _.indexOf(daysId,dayId);
        if(isPush>-1){
            daysId = _.without(daysId,dayId);
        }else{
            daysId.push(dayId);
        }
        this.setState({daysId: daysId},function(){
            self._setTabSelected();
        });
    },
    /**
     * 选择城市
     * @param cityId
     */
    handle_setCity(cityId){
        var citiesId = this.state.citiesId;
        var isPush = _.indexOf(citiesId,cityId);
        if(isPush>-1){
            citiesId = _.without(citiesId,cityId);
        }else{
            citiesId.push(cityId);
        }
        var self =this;
        this.setState({citiesId: citiesId},function(){
            self._setTabSelected();
        });
    },
    /**
     * 查看更多玩法
     */
    handle_openViewTopics(){
        var openTopics = this.state.openViewTopics ? false : true;
        this.setState({openViewTopics: openTopics})
    },/**
     * 查看更多城市
     */
    handle_openViewCities(){
        var openCities = this.state.openViewCities ? false : true;
        this.setState({openViewCities: openCities})
    },
    /**
     * 查看更多亮点
     */
    handle_openViewHighlights(){
        var openHighlights = this.state.openViewHighlights ? false : true;
        this.setState({openViewHighlights: openHighlights})
    },
    /**
     * 查看更多天数
     */
    handle_openViewDays(){
        var openDays = this.state.openViewDays ? false : true;
        this.setState({openViewDays: openDays})
    },
    /**
     * 选择排序
     * @param cityId
     */
    handle_setSort(sortId){
        var self =this;
        var currentSortId = this.state.sortId;
        sortId = currentSortId===sortId ? null : sortId;
        this.setState({sortId: sortId},function(){
            self._setTabSelected();
        });
    },
    /**
     * 确认查询
     */
    handle_result(isPageReset){
        var state = this.state;
        var data = {
            continent: state.continentId,
            countries: state.countryId,
            branch: state.branchId,
            topics: state.topicsId.join(','),
            cities: state.citiesId.join(','),
            highlights: state.highlightId,
            day: state.daysId.join(','),
            sort: state.sortId,
            page: isPageReset ? 1 : state.page,
            pageSize: state.pageSize,
            walleHasStartFalg: 0
        }
        this.setState({
            page: isPageReset ? 1 : state.page,
            scrollTop: 0,
            filterData: {
            continentId: state.continentId,
            countryId: state.countryId,
            branchId: state.branchId,
            topicsId: state.topicsId,
            citiesId: state.citiesId,
            highlightId: state.highlightId,
            daysId: state.daysId,
            sortId: state.sortId
         }});

        $(window).scrollTop(0);

        this._setQueryParams(data);

        Dispatcher.dispatch({type: ActionConstants.SEARCH_POWER_LIST, data: data});
    },
    /**
     * 清除选择的结果
     */
    handle_reset(){
        this.setState({
            continentId: null,
            countryId: null,
            branchId: null,
            topicsId: [],
            citiesId: [],
            highlightId: null,
            daysId: [],
            sortId: null,
            page: 1,
            openViewCities: false,
            openViewHighlights: false,
            isSelectedTarget: false,
            isSelectedMore: false,
            isSelectedSort: false,
            walleHasStartFalg: 0
        });
    },
    handle_scroll(){
        var self = this;

        $(window).scroll(_.throttle(function(){
            var menuFilger = $(".mod-target-filter");
            var menuOffset = menuFilger.offset();
            var menuTop = menuOffset.top;
            var navWrap = menuFilger.find(".nav");
            var filterType = self.state.filterType;

            if ($(window).scrollTop() >= menuTop || filterType) {
                if(!navWrap.hasClass("fixed")){
                    navWrap.addClass("fixed")
                }

            }else{
                if(navWrap.hasClass("fixed")){
                    navWrap.removeClass("fixed")
                }
            }

            var offset = 90;
            var height = $(window).scrollTop() + $(window).height() + offset;
            if($(document).height() < height){
                if( self.state.scrollTop >= height ){
                    return
                }
                self.setState({scrollTop: height},function(){
                    self.handle_loadList();
                });
            }
        },500));

        $('body').on('touchstart', '.shim', function(e) {

        });
        $('body').on('touchmove', '.shim', function(e) {
            //e.preventDefault();
            e.stopPropagation();
            return false;
        });
        $('body').on('touchend', '.shim', function(e) {

        });

    },
    /**
     * 滚动加载数据
     */
    handle_loadList(){
        var isPowerListLast = ALikeStore.get_isPowerListLast();
        if(isPowerListLast){
            return;
        }
        var state = this.state;
        var data = {
            continent: state.continentId,
            countries: state.countryId,
            branch: state.branchId,
            topics: state.topicsId.join(','),
            cities: state.citiesId.join(','),
            highlights: state.highlightId,
            day: state.daysId.join(','),
            sort: state.sortId,
            page: state.page+1,
            pageSize: state.pageSize,
            walleHasStartFalg: state.walleHasStartFalg
        }
        this.setState({page: data.page, pageSize: data.pageSize});
        this._setQueryParams(data);
        Dispatcher.dispatch({type: ActionConstants.LOAD_POWER_LIST, data: data});
    },
    /**
     * 点击空白隐藏content
     */
    handle_hideContent(){
        this.setState({filterType: null});
        this._setCurrentFilter();
        this.handle_filterContentPosition();
    },
    /**
     * 基于上一次查询条件,渲染当前的filter menu
     * @private
     */
    _setCurrentFilter(){
        var self = this;
        var filterData = this.state.filterData;
        this.setState({
            continentId: filterData.continentId,
            countryId: filterData.countryId,
            branchId: filterData.branchId,
            topicsId: filterData.topicsId,
            citiesId: filterData.citiesId,
            highlightId: filterData.highlightId,
            daysId: filterData.daysId,
            sortId: filterData.sortId
        },function(){
            self._setTabSelected();
        })
    },
    /**
     * 渲染tab切换按钮
     * @returns {Array}
     * @private
     */
    _renderTab(){
        var self = this;
        var filterType = this.state.filterType;
        var items = [];
        _.map(FilterType.list, function (item, index) {
            var isSelected = +item.code === filterType ? true : false;
            var itemClazz = object2class({
                'item': true,
                'is-selected': isSelected
            });
            var tabSelected = self._getTabSelected(item.code);
            var tabClazz = object2class({
                "icon-power-list-item-default": !tabSelected,
                "icon-power-list-item-isselected": tabSelected
            });

            items.push(
                <div className={itemClazz} key={index} data-code={item.code} onClick={()=>{self.handle_switchTab(item.code)}}>
                    <div className="lab">{item.name}</div>
                    <i className={tabClazz}></i>
                </div>
            );
        });
        return items;
    },
    /**
     * 渲染过滤器内容
     * @private
     */
    _renderContent(){
        var filterType = this.state.filterType;
        var menuContent = null;
        switch(filterType){
            case FilterType.Targe.code:
                menuContent = this.handle_renderTarget();
                break;

            case FilterType.More.code:
                menuContent = this.handle_renderMore();
                break;

            case FilterType.Sort.code:
                menuContent = this.handle_renderSort();
                break;
        }
        return menuContent;
    },
    /**
     * 目的地渲染
     */
    handle_renderTarget(){
        var self = this;

        var continentId = this.state.continentId;
        var countryId = this.state.countryId;
        var branchId = this.state.branchId;

        //渲染大洲
        var continents = ALikeStore.get_continents();
        var continentsItems = _.map(continents, function (item, index) {
            var isSelected = +item.continentId === continentId ? true : false;
            var itemClazz = object2class({
                "txt": true,
                "is-selected": isSelected
            });
            return (
                <li className={itemClazz} key={index} data-id={item.continentId} onClick={()=>{self.handle_setContinent(item.continentId)}}>
                    {item.continentName}
                </li>
            );
        });
        //渲染国家
        var countriesItems = null;
        if(continentId){
            var countries = ALikeStore.get_countries(continentId);
            countriesItems = _.map(countries, function (item, index) {
                var isSelected = +item.countryId === countryId ? true : false;
                var itemClazz = object2class({
                    "txt": true,
                    "is-selected": isSelected
                });
                return (
                    <li className={itemClazz} key={index} data-id={item.countryId} onClick={()=>{self.handle_setCountry(item.countryId)}}>
                        {item.countryName}
                    </li>
                );
            });
        }
        //渲染分线
        var branchesItems = null;
        if(countryId){
            var branches = ALikeStore.get_branches(continentId, countryId);
            branchesItems = _.map(branches, function (item, index) {
                var isSelected = +item.branchId === branchId ? true : false;
                var itemClazz = object2class({
                    "txt": true,
                    "is-selected": isSelected
                });
                var selectedClass = object2class({
                    "icon-power-list-s1": isSelected,
                    "icon-power-list-s2": !isSelected
                });
                return (
                    <li className={itemClazz} key={index} data-id={item.branchId} onClick={()=>{self.handle_setBranch(item.branchId)}}>
                        {item.branchName}
                        <i className={selectedClass}></i>
                    </li>
                );
            });
        }

        return(
            <div className="menu-content">
                <div className="menu-target">
                    <div className="cate-1-wrap">
                        <ul className="cate-1">
                            {continentsItems}
                        </ul>
                    </div>
                    <div className="cate-2-wrap">
                        <ul className="cate-2">
                            {countriesItems}
                        </ul>
                    </div>
                    <div className="cate-3-wrap">
                        <ul className="cate-3">
                            {branchesItems}
                        </ul>
                    </div>
                </div>
            </div>
        )
    },
    /**
     * 更多渲染
     */
    handle_renderMore(){
        var self = this;
        //渲染主题
        var topicsId = this.state.topicsId;
        var topicsItems = null;
        var topics = ALikeStore.get_topics();
        topicsItems = _.map(topics, function (item, index) {
            var isSelected = _.indexOf(topicsId,+item.tagId )>-1 ? true : false;
            var itemClazz = object2class({
                "c-tag": true,
                "is-selected": isSelected
            });
            return (
                <li className={itemClazz} key={index} data-id={item.tagId} onClick={()=>{self.handle_setTopic(item.tagId)}}>
                    <span>{item.tagName}</span>
                </li>
            );
        });
        //渲染出行天数
        var daysId = this.state.daysId;
        var daysItems = null;
        var days = ALikeStore.get_days();
        daysItems = _.map(days, function (item, index) {
           // var isSelected = item.id === dayId ? true : false;
            var isSelected =  _.indexOf(daysId,item.id )>-1 ? true : false;
            var itemClazz = object2class({
                "c-tag": true,
                "is-selected": isSelected
            });
            return (
                <li className={itemClazz} key={index} data-id={item.id} onClick={()=>{self.handle_setDay(item.id)}}>
                    <span>{item.name}</span>
                </li>
            );
        });

        var continentId = this.state.continentId;
        var countryId = this.state.countryId;
        var branchId = this.state.branchId;
        //渲染城市/景点
        var citiesId = this.state.citiesId;
        var citiesItems = null;
        if(countryId){
            var cities = ALikeStore.get_cities(continentId, countryId, branchId);
            citiesItems = _.map(cities, function (item, index) {
                var isSelected = _.indexOf(citiesId,+item.locationId )>-1 ? true : false;
                var itemClazz = object2class({
                    "c-tag": true,
                    "is-selected": isSelected
                });
                return (
                    <li className={itemClazz} key={index} data-id={item.locationId} onClick={()=>{self.handle_setCity(item.locationId)}}>
                        <span>{item.cityName}</span>
                    </li>
                );
            });
        }
        //渲染亮点
        var highlightId = this.state.highlightId;
        var highlightsItems = null;
        if(countryId){
            var highlights = ALikeStore.get_highlights(continentId, countryId, branchId);
            highlightsItems = _.map(highlights, function (item, index) {
                var isSelected = +item.tagId === highlightId ? true : false;
                var itemClazz = object2class({
                    "c-tag": true,
                    "is-selected": isSelected
                });
                return (
                    <li className={itemClazz} key={index} data-id={item.tagId} onClick={()=>{self.handle_setHighlight(item.tagId)}}>
                        <span>{item.tagName}</span>
                    </li>
                );
            });
        }
        //展开查看更多玩法
        var openViewTopics = this.state.openViewTopics;
        var openTopicsClazz = object2class({
            "open-view-more": openViewTopics
        });
        var openTopicsStateClass = object2class({
            "icon-power-list-r1": openViewTopics,
            "icon-power-list-r2": !openViewTopics
        });
        //展开查看更多城市
        var openViewCities = this.state.openViewCities;
        var openCitiesClazz = object2class({
            "open-view-more": openViewCities
        });
        var openCitiesStateClass = object2class({
            "icon-power-list-r1": openViewCities,
            "icon-power-list-r2": !openViewCities
        });
        //展开查看更多亮点
        var openViewHighlights = this.state.openViewHighlights;
        var openHighlightsClazz = object2class({
            "open-view-more": openViewHighlights
        });
        var openHighlightsStateClass = object2class({
            "icon-power-list-r1": openViewHighlights,
            "icon-power-list-r2": !openViewHighlights
        });

        //展开查看更多天数
        var openViewDays = this.state.openViewDays;
        var openDaysClazz = object2class({
            "open-view-more": openViewDays
        });
        var openDaysStateClass = object2class({
            "icon-power-list-r1": openViewDays,
            "icon-power-list-r2": !openViewDays
        });

        return(
            <div className="menu-content">
                <div className="menu-type">
                    <dl className={openTopicsClazz}>
                        <dt>玩法（可多选）
                            {topicsItems.length>8 ? (
                                <span className="view-more" onClick={this.handle_openViewTopics}>查看所有
                                        <i className={openTopicsStateClass}></i>
                                    </span>
                            ) : null}

                        </dt>
                        <dd>
                            <ul className="cell-tags">
                                {topicsItems}
                            </ul>
                        </dd>
                    </dl>
                    {citiesItems && citiesItems.length? (
                        <dl className={openCitiesClazz}>
                            <dt>城市（可多选）
                                {citiesItems.length>8 ? (
                                    <span className="view-more" onClick={this.handle_openViewCities}>查看所有
                                        <i className={openCitiesStateClass}></i>
                                    </span>
                                ) : null}

                            </dt>
                            <dd>
                                <ul className="cell-tags city-tags">
                                    {citiesItems}
                                </ul>
                            </dd>
                        </dl>
                    ):null}
                    <dl className={openDaysClazz}>
                        <dt>天数（可多选）
                            {daysItems.length>8 ? (
                                <span className="view-more" onClick={this.handle_openViewDays}>查看所有
                                        <i className={openDaysStateClass}></i>
                                    </span>
                            ) : null}
                        </dt>
                        <dd>
                            <ul className="cell-tags">
                                {daysItems}
                            </ul>
                        </dd>
                    </dl>
                    {highlightsItems && highlightsItems.length ? (
                        <dl className={openHighlightsClazz}>
                            <dt>特别亮点
                                {highlightsItems.length>8 ? (
                                    <span className="view-more" onClick={this.handle_openViewHighlights}>查看所有
                                        <i className={openHighlightsStateClass}></i>
                                    </span>
                                ) : null}

                            </dt>
                            <dd>
                                <ul className="cell-tags">
                                    {highlightsItems}
                                </ul>
                            </dd>
                        </dl>
                    ) : null}
                </div>
            </div>
        )
    },
    /**
     * 排序渲染
     */
    handle_renderSort(){
        var self = this;
        var sortId = this.state.sortId;
        var sortItems = null;
        var sorts = ALikeStore.get_sorts();
        sortItems = _.map(sorts, function (item, index) {
            var isSelected = item.sortId === sortId ? true : false;
            var itemClazz = object2class({
                "c-sort": true,
                "is-selected": isSelected
            });
            var selectedClass = object2class({
                "icon-power-list-s1": isSelected,
                "icon-power-list-s2": !isSelected
            });
            return (
                <li className={itemClazz} key={index} data-id={item.sortId} onClick={()=>{self.handle_setSort(item.sortId)}}>
                    {item.sortName}
                    <i className={selectedClass}></i>
                </li>
            );
        });
        return(
            <div className="menu-content">
                <div className="menu-sort">
                    <ul className="cell-sorts">
                        {sortItems}
                    </ul>
                </div>
            </div>
        )
    },
    render(){
        var self= this;
        var filterType = this.state.filterType;

        return(
            <div className="navWrap">
                <div className="nav">
                    {this._renderTab()}
                </div>
                {!filterType ? null : (
                    <div className="shim" style={{display: "block"}} onClick={this.handle_hideContent}></div>
                )}

                <div className="menu">
                    {this._renderContent()}
                    {!filterType ? null : (
                        <div className="clearfix btns">
                            <div className="bt-btn bt-clear"  onClick={this.handle_reset}>重置</div>
                            <div className="bt-btn bt-primary" onClick={()=>{self.handle_result(true)}}>确认</div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
});



/** WEBPACK FOOTER **
 ** ./script/list-m/FilterMenu.jsx
 **/